import React, { useEffect, useState } from 'react';
import TreeItem from '@material-ui/lab/TreeItem';
import LensIcon from '@material-ui/icons/Lens';
import { getFormByIdWithoutAuthen } from '@/service/formManagementService';
import { getTicketDetailAPI } from '@/service/ticketService';
import {  API } from 'aws-amplify';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';

export default function DrilldownTreeItem({ itemChild, argsCommon, item, selectDrilldown, key }) {
    const [itemLabel , setItemLabel] = useState(itemChild?.label);
    const [loading , setLoading] = useState(false);
    useEffect(() => {
        if(!itemLabel) {
            const tagItemType = Utils.getPrefixOfId(itemChild.id);
            setLoading(true);
            if (tagItemType === 'tag') {
                getFormByIdWithoutAuthen(API, itemChild.id).then((fieldDetail) => {
                    let fieldName = Utils.convertJSONDataToObject(fieldDetail?.name);
                    setLoading(false);
                    setItemLabel(fieldName?.jp?.text);
                    
                })
            } else {
                getTicketDetailAPI(API, itemChild.id).then((ticketDetailResult) => {
                    let detailTicket = ticketDetailResult.detailTicket;
                    let titketTitle =  Utils.getTitle(detailTicket?.settingTitle);
                    setLoading(false);
                    setItemLabel(titketTitle);
                    
                })
            }
        }
    }, [itemChild]);

    if (loading) {
       
        return (
            <TreeItem
                className={`itemIcon ${{...item}.usage === Constant.FORM_USAGE.TAG ? 'childTagItem' : 'childItem'}`}
                nodeId={itemChild.id}
                label={'...'}
                onClick={e => selectDrilldown(argsCommon, item, itemChild)}
                icon={<LensIcon  fontSize="small" />}
                key={key}
            />
        )
    }

    return (
        <TreeItem
            className={`itemIcon ${{...item}.usage === Constant.FORM_USAGE.TAG ? 'childTagItem' : 'childItem'}`}
            nodeId={itemChild.id}
            label={<OverFlowTooltipWithTabsMui value={`${itemLabel} ${itemChild.total ? `(${itemChild.total})` : ''}`} />}
            disableselection="true"
            onClick={e => selectDrilldown(argsCommon, item, itemChild)}
            icon={<LensIcon fontSize="small" />}
            key={key}
        />
    );
}
